import React from 'react';
import { useTranslation } from 'react-i18next';
import FormField, { DefaultFormFieldLayout } from 'components/FormField';
import FormStack from 'components/FormStack';
import { TitleCardWithToggle } from 'components/TitleCard';
import TextArea from 'components/TextArea';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function EventSettingsCard(_ref) {
  var isDistributed = _ref.isDistributed,
    fields = _ref.fields;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var joiningInstructions = fields.joiningInstructions,
    bookingInstructions = fields.bookingInstructions;
  return /*#__PURE__*/_jsx(TitleCardWithToggle, {
    variant: "raised",
    title: t('menu_event_settings'),
    defaultOpen: true,
    children: /*#__PURE__*/_jsx(DefaultFormFieldLayout, {
      horizontal: true,
      children: /*#__PURE__*/_jsxs(FormStack, {
        spacing: "m",
        children: [/*#__PURE__*/_jsx(FormField, {
          label: t('form_booking_instructions'),
          children: /*#__PURE__*/_jsx(TextArea, {
            maxRows: 8,
            minRows: 3,
            value: bookingInstructions.value,
            onChange: function onChange(e) {
              return bookingInstructions.set(e.target.value);
            },
            disabled: isDistributed
          })
        }), /*#__PURE__*/_jsx(FormField, {
          label: t('form_joining_instructions'),
          children: /*#__PURE__*/_jsx(TextArea, {
            maxRows: 8,
            minRows: 3,
            value: joiningInstructions.value,
            onChange: function onChange(e) {
              return joiningInstructions.set(e.target.value);
            },
            disabled: isDistributed
          })
        })]
      })
    })
  });
}
export default EventSettingsCard;